export default __webpack_public_path__ + "static/media/misc-books3-1024w.637f61e8.png";